import classNames from "classnames";
import { useFormStore } from "@/widgets/classic-form/form";
import type { PersonSuggestionItem } from "@/entities/tree-person";
import { formatYears, getSuggestionLabel } from "./getSuggestionLabel";
import styles from "./QuickFillItem.module.scss";

interface QuickFillItemProps {
    suggestion: PersonSuggestionItem;
    treeId: string;
    onSelect: (suggestion: PersonSuggestionItem, treeId: string) => void;
}

export const QuickFillItem = ({ suggestion, treeId, onSelect }: QuickFillItemProps) => {
    const isSelected = useFormStore(({ values }) => values.treePerson.personId === suggestion.PersonId);

    const { FullName, BirthYear, DeathYear } = suggestion;
    const label = getSuggestionLabel(suggestion);

    return (
        <button
            type="button"
            data-testid={`suggestionItem-${treeId}-${suggestion.PersonId}`}
            aria-pressed={isSelected}
            aria-label={label}
            title={label}
            className={classNames("iconAdd", styles.quickFillItem, isSelected && styles.selected)}
            onClick={() => onSelect(suggestion, treeId)}
        >
            <h4>{FullName}</h4>
            <span>{formatYears(BirthYear, DeathYear)}</span>
        </button>
    );
};
